<template>
  <fn-form-friends-light-discount
    v-if="!allChecksPassed"
    :errors="errors"
    :loading="loading"
    :button-disabled="buttonDisabled"
    :required-notice="requiredNotice"
    legal-hidden
    full-width-inputs
    redirect-disabled
    @submit="handleSubmit"
  />
</template>

<script>
import { LOYALTY_TYPES } from '@/utils/loyalty';
import newsletter from '@/mixins/Newsletter';

export default defineComponent({
  mixins: [newsletter],
  props: {
    buttonDisabled: {
      type: Boolean,
    },
    requiredNotice: {
      type: Boolean,
    },
    legalHidden: {
      type: Boolean,
    },
    redirectDisabled: {
      type: Boolean,
    },
    friendsLight: {
      type: Boolean,
    },
    fullWidthInputs: {
      type: Boolean,
    },
  },
  data: () => ({
    errors: null,
    loading: false,
  }),
  computed: {
    ...mapState(useUserStore, {
      termsOfServiceAccepted: 'termsOfServiceAccepted',
      friendsLightQrCode: 'getFriendsLightQrCode',
      hasFriendsBenefit: 'getHasFriendsBenefit',
    }),
    allChecksPassed() {
      return (
        (this.termsOfServiceAccepted || this.hasFriendsBenefit) &&
        this.hasNewsletterSubscription &&
        !this.friendsLightQrCode
      );
    },
  },
  watch: {
    allChecksPassed() {
      if (this.allChecksPassed) {
        this.handleSubmit({});
      }
    },
  },
  beforeMount() {
    if (this.allChecksPassed) {
      this.handleSubmit({});
    }
  },
  methods: {
    ...mapActions(useUserStore, {
      activateFriends: 'activateFriends',
      getFriendsLightQrCode: 'retrieveFriendsLightQrCode',
    }),

    async handleSubmit({ newsletterConsent = false, newsletterRecaptchaResponse = null }) {
      this.loading = true;
      const activationParams = {
        loyaltyType: LOYALTY_TYPES.FRIENDS_LIGHT,
      };

      try {
        await this.activateFriends(activationParams);
        await this.getFriendsLightQrCode();

        if (newsletterConsent) {
          this.registerToNewsletter(newsletterRecaptchaResponse);
        }
      } catch (error) {
        this.$log.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
});
</script>
